import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'jquery';
import { Button } from './styles';

const UnifyButton = ({
  color, children, textColor, onClick, style, className, type,
}) => (
  <Button
    className={className}
    buttonColor={color}
    textColor={textColor}
    onClick={onClick}
    style={style}
    type={type}
  >
    {children}
  </Button>
);

UnifyButton.defaultProps = {
  color: '#000000',
  className: '',
  onClick: noop,
  textColor: '#ffffff',
  style: {},
  type: '',
  children: <div>Nothing</div>,
};

UnifyButton.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  textColor: PropTypes.string,
  style: PropTypes.shape({}),
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default UnifyButton;
